import { Colors } from '../../../../core/models/disciplines';
import { TagVariants } from './variants';

const Tag = ({
  text,
  disabled,
  type = 'default',
  hasVinculed,
  color,
}: {
  text: string;
  disabled?: boolean;
  type?: 'default' | 'review';
  hasVinculed?: boolean;
  color?: Colors;
}) => {
  return (
    <span
      className={TagVariants({
        disabled,
        type,
        hasVinculed,
        color,
      })}
    >
      {text}
    </span>
  );
};
export default Tag;
